import { Component, Input, OnDestroy, OnInit, viewChild, ViewContainerRef } from '@angular/core';
import { Alert } from './alert.model';
import { CommonModule } from '@angular/common';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'alert',
  standalone: true,
  imports: [CommonModule, I18nModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent implements OnInit, OnDestroy {
  vcr = viewChild('dynamicContainer', { read: ViewContainerRef });

  @Input() alert!: Alert;

  ngOnInit(): void {
    if (this.alert.hasCloseButton === undefined) {
      this.alert.hasCloseButton = true;
    }

    if (this.alert.component) {
      this.vcr()?.createComponent(this.alert.component);
    }
  }

  ngOnDestroy(): void {
    this.clearComponent();
  }

  close() {
    this.alert.isActive = false;
  }

  clearComponent() {
    this.vcr()?.clear();
  }
}
